import { render, staticRenderFns } from "./TheCookieBar.vue?vue&type=template&id=7f137827&scoped=true&"
import script from "./TheCookieBar.vue?vue&type=script&lang=js&"
export * from "./TheCookieBar.vue?vue&type=script&lang=js&"
import style0 from "./TheCookieBar.vue?vue&type=style&index=0&id=7f137827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f137827",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Weboldal/weboldal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VIcon,VSnackbar})
